import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface RemovePositionWishFromCandidateResponse
  extends BackendResponse {}
export interface RemovePositionWishFromCandidateParameters
  extends NextApiParams {
  positionType: number;
}

export const removePositionWishFromCandidate = withNextApi<
  RemovePositionWishFromCandidateResponse,
  RemovePositionWishFromCandidateParameters
>("/cvp/CvpRemovePositionWishFromCandidate");
